import { siteMeta } from "../data/siteMeta";
import { trackEvent } from "../lib/telemetry";

export default function SocialLink({ children = "Follow on X", className = "button", source = "site", withArrow = false }) {
  function handleClick() {
    trackEvent("Social Link Clicked", {
      platform: "X",
      source,
      target_url: siteMeta.socialUrl,
    });
  }

  return (
    <a className={className} href={siteMeta.socialUrl} target="_blank" rel="me noopener noreferrer" onClick={handleClick}>
      {children}
      {withArrow ? <span aria-hidden="true">&gt;</span> : null}
    </a>
  );
}
